module.exports = __webpack_public_path__ + "img/body-2.37e24179.png";